export const apiBaseUrl = './shopping/api/v1'
